// extracted by mini-css-extract-plugin
export default {"milestoneWrapper":"milestone_milestoneWrapper__SUh29","milestoneBackground":"milestone_milestoneBackground__cXe-8"};